const MapLoader = () => {
  return (
    <div className="col-12 col-xl-6">
      <div className="card shadow-sm border-0">
        <div
          className="card-body p-2 d-flex justify-content-center align-items-center"
          style={{ height: "76vh", backgroundColor: "#f8f9fa" }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary" role="status" aria-label="Loading map">
              <span className="sr-only">Loading...</span>
            </div>
            <p className="mt-3 mb-0 text-muted">Loading map...</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapLoader;
